import type { JointOrigin } from '@/types/robotEvents'

// URDF joint の表示名 (fork_webapp_react のキャリブレーション画面が書き換える対象)
export const JOINT_LABELS: Record<string, string> = {
  top_lidar_joint: 'トップ LiDAR ヨー',
  camera_joint: '横カメラ',
}

// 計測方法の表示名 (fork_config/vehicles/fork_factory/calibration.yaml の method)
export const METHOD_LABELS: Record<string, string> = {
  straight_run: '直進走行',
  tag_on_pole: 'ポールのタグ板',
  pointcloud: '点群合わせ',
  manual_pose: '手動姿勢',
}

const RAD_TO_DEG = 180 / Math.PI

export const deg = (rad: number, digits = 2) =>
  `${(rad * RAD_TO_DEG).toFixed(digits)}°`
const cm = (m: number) => `${(m * 100).toFixed(1)} cm`
const signed = (text: string) => (text.startsWith('-') ? text : `+${text}`)

// origin を項目に応じて要約する。トップ LiDAR は yaw だけ、横カメラは x / y / yaw
export function describeOrigin(joint: string, o: JointOrigin | null): string {
  if (!o) return '－'
  if (joint === 'top_lidar_joint') return `yaw ${deg(o.rpy[2])}`
  return `x ${o.xyz[0].toFixed(4)} / y ${o.xyz[1].toFixed(4)} m, yaw ${deg(o.rpy[2])}`
}

// 変更量 (after − before)。横カメラは x / y の cm と yaw、LiDAR は yaw のみ
export function describeDelta(
  joint: string,
  before: JointOrigin | null,
  after: JointOrigin | null
): string {
  if (!before || !after) return '－'
  const dyaw = signed(deg(after.rpy[2] - before.rpy[2]))
  if (joint === 'top_lidar_joint') return dyaw
  const dx = after.xyz[0] - before.xyz[0]
  const dy = after.xyz[1] - before.xyz[1]
  const parts: string[] = []
  if (Math.abs(dx) >= 0.0005) parts.push(`x ${signed(cm(dx))}`)
  if (Math.abs(dy) >= 0.0005) parts.push(`y ${signed(cm(dy))}`)
  parts.push(`yaw ${dyaw}`)
  return parts.join(', ')
}
